<template>
  <v-dialog v-model="dialog" max-width="400">
    <template v-slot:activator="{ on }">
      <slot  v-bind:on="on" v-on="on" name="activator">
      </slot>
    </template>
    <v-card v-if="dialog" class="container">
      <v-card-title>{{$t('downloadLogbook')}}</v-card-title>
      <v-card-text>
        <v-checkbox
          persistent-hint
          disabled
          :hint="$t('downloadlogbookasaWordFile')"
          input-value="true"
          :label="$t('Word .docx')"
        ></v-checkbox>
        <v-badge
          :value="$can('download','separated') ? 0 : 'Pro/Expert'"
          :content="$can('download','separated') ? 0 : 'Pro/Expert'"
          bordered
          overlap
        >
          <v-checkbox
            persistent-hint
            :hint="$t('blueprintSeparatedHint')"
            :disabled="!$can('download','separated')"
            v-model="blueprintSeparated"
            :label="$t('blueprintSeparated')"
          ></v-checkbox>
        </v-badge>
        <v-badge
          :value="$can('download','includeCertificates') ? 0 : 'Pro/Expert'"
          :content="$can('download','includeCertificates') ? 0 : 'Pro/Expert'"
          bordered
          overlap
        >
          <v-checkbox
            persistent-hint
            :hint="$t('withDocumentsHint')"
            :disabled="!$can('download','includeCertificates')"
            v-model="withDocuments"
            :label="$t('withDocuments')"
          ></v-checkbox>
        </v-badge>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" block depressed @click="downloadLogbook()">{{$t('download')}}</v-btn>
      </v-card-actions>
    </v-card>
    <loadingDialog :dialog="loading"></loadingDialog>
  </v-dialog>
</template>


<script>
export default {
  data() {
    return {
      dialog: false,
      blueprintSeparated: false,
      withDocuments: false,
      loading: false
    };
  },
  watch: {
    dialog() {},
  },
  methods: {
    downloadLogbook() {
      this.$emit("download", this.blueprintSeparated, this.withDocuments);
      this.dialog = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/DownloadLogbook.vue